import { render, staticRenderFns } from "./ring.vue?vue&type=template&id=6cc56127&scoped=true"
import script from "./ring.vue?vue&type=script&lang=js"
export * from "./ring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc56127",
  null
  
)

export default component.exports